import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DataPesananDapur from '../componen/dapur/DataPesananDapur';

const DapurPages = () => {
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate('/', { replace: true });
  }, [isError, navigate]);

  return (

    <>
      <DataPesananDapur />
    </>
  )
}

export default DapurPages